import React from 'react';
import { Snackbar, Alert, Button, Box } from '@mui/material';
import { useApp } from '../../contexts/AppContext';

const NotificationDisplay = () => {
  const { notifications, removeNotification } = useApp();

  return (
    <>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={notification.action ? 8000 : 5000}
          onClose={() => removeNotification(notification.id)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ mb: notifications.indexOf(notification) * 7 }}
        >
          <Alert
            onClose={() => removeNotification(notification.id)}
            severity={notification.type}
            variant="filled"
            sx={{ 
              minWidth: 300,
              '& .MuiAlert-message': {
                width: '100%',
                whiteSpace: 'pre-line'
              }
            }}
            action={
              notification.action && (
                <Button
                  color="inherit"
                  size="small"
                  onClick={() => {
                    notification.action.onClick();
                    removeNotification(notification.id);
                  }}
                  sx={{ 
                    ml: 1,
                    bgcolor: 'rgba(255,255,255,0.2)',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.3)'
                    }
                  }}
                >
                  {notification.action.label}
                </Button>
              )
            }
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
};

export default NotificationDisplay;